module.exports = __webpack_public_path__ + "assets/0.1.11/img/401.089007e7.gif";